import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as $ from 'jquery';
import Alert from '../../../itrust_common/components/Alert';

import { examEdit } from '../../../redux/actions/exam/examActions';
import { onBoardingTourInfoUpdate } from '../../../redux/actions/onBoardingActions';
import { quickActionsReset } from '../../../redux/actions/dashboard/quickActionActions';
import { patientReset } from '../../../redux/actions/patient/patientActions';

class CreateExamButton extends Component {

  handleExamEdit(id, data) {
    const { activeTourType, dispatch, isQuickAction } = this.props;

    if (localStorage.getItem('StoreID') == null) {
      Alert.warning("Please select store from top dropdown.")
    } else {
      isQuickAction && this.handleQuickActionClose()
      this.props.dispatch(examEdit(id, data));
      setTimeout(() => {
        $('#newExamForm-modal').modal('show');
        activeTourType === 'create_exam' && dispatch(onBoardingTourInfoUpdate({ stepIndex: 1, isTourActive: true, activeTourType: 'create_exam' }))
      }, 1000)
    }
  }

  handleQuickActionClose() {
    const { dispatch, isQuickAction } = this.props;
    $('#patientSelect-modal').modal('hide');
    if (isQuickAction) {
      dispatch(quickActionsReset())
    }
    else {
      dispatch(patientReset())
    }
  }

  render() {
    const { patientId, defaultProcedureIds, appointmentId, staffId } = this.props;
    return (
      <span>
        <span
          className="pointer"
          onClick={this.handleExamEdit.bind(this, 'New', { patientId, appointmentId, defaultProcedureIds, staffId })}
        >
          {this.props.children}
        </span>
      </span>
    );
  }
}

export default connect()(CreateExamButton);
